export default __webpack_public_path__ + "static/media/pizza-salami-1080x721.1b2f4401.jpg";